import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isCurrentUserAdmin } from '../../utils/token';

const AdminGuard = ({ children }) => {
  const { account } = useAuth();

  // Check JWT isAdmin flag (server-controlled)
  const userHasAdminAccess = isCurrentUserAdmin();

  if (!userHasAdminAccess) {
    // Log the access attempt for security monitoring
    console.warn('Unauthorized admin access attempt:', {
      userUuid: account?.uuid,
      email: account?.email,
      timestamp: new Date().toISOString()
    });
    
    // Redirect non-admin users to the main bookmarks page
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminGuard;